import { Look } from "./types";

export const looks: Look[] = [
  {
    id: 5,
    title: "Novelty look",
    imagePath: "/looks-gallery/looks-gallery/5/look.avif",
    videoPath: "/looks-gallery/looks-gallery/5/video.mp4",
    products: [
      {
        id: 1,
        label: "Teint fétiche",
        description: "Le Fluide",
        imagePath: "/looks-gallery/looks-gallery/5/products/1.avif",
      },
      {
        id: 2,
        label: "Rouge Stiletto",
        description: "Vinyl Gloss",
        detail: "Hot Sienna 432 V",
        imagePath: "/looks-gallery/looks-gallery/5/products/2.webp",
      },
      {
        id: 3,
        label: "Les yeux noirs",
        description: "Volumaxima",
        detail: "Black 100",
        imagePath: "/looks-gallery/looks-gallery/5/products/3.avif",
      },
      {
        id: 4,
        label: "Glamliner",
        description: "Lips & Eyes",
        detail: "Cocoa Curve",
        imagePath: "/looks-gallery/looks-gallery/5/products/4.avif",
      },
    ],
  },

  {
    id: 4,
    title: "Seasonal look",
    imagePath: "/looks-gallery/looks-gallery/4/look.avif",
    videoPath: "/looks-gallery/looks-gallery/4/video.mp4",
    products: [
      {
        id: 1,
        label: "Teint fétiche",
        description: "Le Baume de Teint",
        imagePath: "/looks-gallery/looks-gallery/4/products/1.webp",
      },
      {
        id: 2,
        label: "Rouge Louboutin",
        description: "Velvet Matte",
        detail: "Beige Very Gil 015",
        imagePath: "/looks-gallery/looks-gallery/4/products/2.webp",
      },
      {
        id: 3,
        label: "Les yeux noirs",
        description: "Lift Ultima",
        detail: "Black 100",
        imagePath: "/looks-gallery/looks-gallery/4/products/3.avif",
      },
      {
        id: 4,
        label: "Glamliner",
        description: "Lips & Eyes",
        detail: "Nude Sketch",
        imagePath: "/looks-gallery/looks-gallery/4/products/4.avif",
      },
    ],
  },
  {
    id: 1,
    title: "Rouge Diva",
    imagePath: "/looks-gallery/looks-gallery/1/look.avif",
    videoPath: "/looks-gallery/looks-gallery/1/video.mp4",
    products: [
      {
        id: 1,
        label: "Teint fétiche",
        description: "Le Baume de Teint",
        imagePath: "/looks-gallery/looks-gallery/1/products/1.avif",
      },
      {
        id: 2,
        label: "Rouge Stiletto",
        description: "Glossy shine",
        detail: "Rouge Louboutin 001",
        imagePath: "/looks-gallery/looks-gallery/1/products/2.avif",
      },
      {
        id: 3,
        label: "Les yeux noirs",
        description: "Volumaxima",
        detail: "Black 100",
        imagePath: "/looks-gallery/looks-gallery/1/products/3.avif",
      },
      {
        id: 4,
        label: "Abracadabra",
        description: "Le duo",
        detail: "Silver Spike",
        imagePath: "/looks-gallery/looks-gallery/1/products/4.avif",
      },
    ],
  },
  {
    id: 2,
    title: "Atomic brick",
    imagePath: "/looks-gallery/looks-gallery/2/look.avif",
    videoPath: "/looks-gallery/looks-gallery/2/video.mp4",
    products: [
      {
        id: 1,
        label: "Teint fétiche",
        description: "Le Cushion",
        imagePath: "/looks-gallery/looks-gallery/2/products/1.avif",
      },
      {
        id: 2,
        label: "Rouge Stiletto",
        description: "Lumi-Matte",
        detail: "Brown Passion Red Wood",
        imagePath: "/looks-gallery/looks-gallery/2/products/2.avif",
      },
      {
        id: 3,
        label: "Les yeux noirs",
        description: "Œil Velours",
        detail: "Khol 001",
        imagePath: "/looks-gallery/looks-gallery/2/products/3.avif",
      },
      {
        id: 4,
        label: "Abracadabra",
        description: "Le duo",
        detail: "Pluminette Mauve",
        imagePath: "/looks-gallery/looks-gallery/2/products/4.avif",
      },
    ],
  },
  {
    id: 3,
    title: "Explosive green",
    imagePath: "/looks-gallery/looks-gallery/3/look.avif",
    videoPath: "/looks-gallery/looks-gallery/3/video.mp4",
    products: [
      {
        id: 1,
        label: "Teint fétiche",
        description: "Le Fluide",
        imagePath: "/looks-gallery/looks-gallery/3/products/1.avif",
      },
      {
        id: 2,
        label: "Rouge Louboutin",
        description: "Silky Satin",
        detail: "Soft Goji 355",
        imagePath: "/looks-gallery/looks-gallery/3/products/2.avif",
      },

      {
        id: 3,
        label: "Tape à l’œil",
        description: "Amazonite",
        imagePath: "/looks-gallery/looks-gallery/3/products/3.avif",
      },

      {
        id: 4,
        label: "Abracadabra",
        description: "Le duo",
        detail: "Silver Spike",
        imagePath: "/looks-gallery/looks-gallery/3/products/4.avif",
      },
    ],
  },
];
